// extracted by mini-css-extract-plugin
module.exports = {"SiteTitle":"styles-module--SiteTitle--1lB92"};